// extracted by mini-css-extract-plugin
export var deleteModal = "_dd-0";